import ApiClient from '../shared/ApiCliente';

export type EmailPreference = 'TODOS' | 'DIARIO' | 'HORA' | 'NENHUM';

export type EmailPreferencesResponse = {
  emailPreferences: EmailPreference;
  status: string;
};

export type EmailPreferencesResult = {
  ok: boolean;
  data?: EmailPreferencesResponse;
};

export const emailPreferencesService = {
  updateEmailPreferences: async (
    emailPreferences: EmailPreference
  ): Promise<EmailPreferencesResult> => {
    try {
      const response = await ApiClient.post<EmailPreferencesResponse>('/usuario/email', { emailPreferences });
      return {
        ok: response.status >= 200 && response.status < 300,
        data: response.data,
      };
    } catch (error) {
      console.error('Erro ao atualizar preferências de email:', error);
      return { ok: false };
    }
  },
};

